import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle2, Lock } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Senha precisa ter no mínimo 6 caracteres"); return; }
    if (password !== confirm) { toast.error("As senhas não batem"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      toast.success("Senha atualizada!");
      setTimeout(() => nav("/login"), 1500);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Link inválido ou expirado");
    } finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="grid-bg min-h-[85vh] flex items-center justify-center px-4">
        <div className="brutal-card max-w-md text-center" style={{borderColor:'#FF0055'}}>
          <h2 className="font-bebas text-4xl tracking-tighter">Link inválido</h2>
          <p className="text-white/60 mt-3 font-manrope">Volta pra recuperação e pede um novo link.</p>
          <Link to="/forgot-password" className="brutal-btn w-full mt-6">Recuperar senha</Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="reset-page" className="grid-bg min-h-[85vh] flex items-center px-4 py-16">
      <div className="max-w-md mx-auto w-full">
        {done ? (
          <div data-testid="reset-done" className="brutal-card brutal-shadow text-center" style={{borderColor:'#CCFF00'}}>
            <CheckCircle2 className="mx-auto text-[#CCFF00]" size={64}/>
            <h2 className="font-bebas text-4xl tracking-tighter mt-4">Senha atualizada!</h2>
            <p className="text-white/70 mt-3 font-manrope">Redirecionando pro login...</p>
          </div>
        ) : (
          <>
            <span className="sticker inline-block">NOVA SENHA</span>
            <h1 className="font-bebas text-6xl mt-6 tracking-tighter">CRIA UMA NOVA</h1>
            <p className="text-white/60 mt-3 font-manrope">Escolhe uma senha nova pra tua conta.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div className="relative">
                <Lock className="absolute left-3 top-4 text-white/40" size={18}/>
                <input
                  data-testid="reset-password"
                  required
                  type="password"
                  minLength={6}
                  value={password}
                  onChange={(e)=>setPassword(e.target.value)}
                  placeholder="Nova senha (min 6)"
                  className="brutal-input"
                  style={{paddingLeft:'2.5rem'}}
                />
              </div>
              <div className="relative">
                <Lock className="absolute left-3 top-4 text-white/40" size={18}/>
                <input
                  data-testid="reset-confirm"
                  required
                  type="password"
                  minLength={6}
                  value={confirm}
                  onChange={(e)=>setConfirm(e.target.value)}
                  placeholder="Confirma a nova senha"
                  className="brutal-input"
                  style={{paddingLeft:'2.5rem'}}
                />
              </div>
              <button data-testid="reset-submit" disabled={loading} className="brutal-btn w-full">
                {loading ? "Salvando..." : "Salvar nova senha"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
